
  import { Options, Vue } from "vue-class-component";
  import { useMeta } from "vue-meta";
  import { IReCaptchaComposition, VueReCaptcha, useReCaptcha } from "vue-recaptcha-v3";
  import router from "./router"

  const isNotProd = ["preprod", "azurewebsites", "-staging-", ".inprogress.co.za"].some(term => window.location.origin.toLowerCase().includes(term));

  @Options({
    beforeRouteUpdate(to, from, next) {
      this.hideRecaptcha();
    },
  })
  export default class App extends Vue {
    recapthcaObject: IReCaptchaComposition | undefined = undefined;

    mounted() {
      this.recapthcaObject = useReCaptcha() as IReCaptchaComposition;
      const { meta } = useMeta({
        title: "",
        description: "",
        keywords: "",
        og: {
          title: '',
          description: '',
          type: '',
          url: ''
        },
        htmlAttrs: { lang: 'en', amp: true }
      });

      this.hideRecaptcha();
    }

    async hideRecaptcha() {
      if (this.recapthcaObject) {
        // Wait until recaptcha has been loaded.
        await this.recapthcaObject.recaptchaLoaded();

        // Hide recaptcha has been loaded.
        const reCapthca = document.querySelector(".grecaptcha-badge") as any;
        if (reCapthca && !["ResidentialContactUs"].includes(this.$route.name as string)) {
          reCapthca.style.visibility = `hidden`;
        } else {
          reCapthca.style.visibility = `visible`;
        }
      }
    }

    robotsFormat (meta: any) {
      const routeName = router.currentRoute.value.name;
      const excludeRoutes = [
        "TermsAndConditions",
        "CookiePolicy",
        "PrivacyPolicy",
        "TermsAndConditionsOnlineQuotation"
      ];
      let robotsContent = undefined;
      if (isNotProd) {
        robotsContent = "noindex, nofollow";
      } else if (meta && meta.metaRobots) {
        robotsContent = meta.metaRobots;
      } else if (!excludeRoutes.includes(routeName as string)) {
        robotsContent = "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
      } else {
        robotsContent = undefined;
      }
      return robotsContent;
    }
  }
